#!/usr/bin/env node

import { main } from './bin';

main(undefined, { '--scriptMode': true });
